import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import { IRetryButtonProps } from './RetryButton.interface';

export const RetryButton: FC<IRetryButtonProps> = ({ className, onClick }) => {
  const { t } = useTranslation();

  return (
    <Button className={className} color="inherit" onClick={onClick}>
      {t('common.retry')}
    </Button>
  );
};

export default RetryButton;
